import React from 'react';
import CourierAreaArrayComboBox from './CourierAreaArrayComboBox';

const courierAreaArray: string[] = [
  'DRAMMEN_SOUTH',
  'DRAMMEN_NORTH',
  'TRANBY_ROYKEN',
  'ASKER',
  'LOMMEDALEN',
  'SANDVIKA',
  'JESSHEIM',
  'SKEDSMOKORSET',
  'LILLESTROM',
  'NITTEDAL',
  'VESTBY',
  'SOFIEMYR',
  'BAERUM',
  'OSLO_12',
  'OSLO_11',
  'OSLO_10',
  'OSLO_09',
  'OSLO_08',
  'OSLO_07',
  'OSLO_06',
  'OSLO_05',
  'OSLO_04',
  'OSLO_03',
  'OSLO_02',
  'OSLO_01',
];

function useGetAreaArray(): { courierAreaArray: string[]; isLoading: boolean } {
  const isLoading = false;
  return { courierAreaArray, isLoading };
}

export function EditCourierArea({
  areaList,
  addAreaListMethod,
}: {
  areaList: string[];
  addAreaListMethod: (areaList: string[]) => void;
}): JSX.Element {
  const { courierAreaArray, isLoading } = useGetAreaArray();

  return (
    <>
      {!isLoading && (
        <CourierAreaArrayComboBox
          placeHolderText={'Area selection'}
          areaList={areaList}
          courierAreaArray={courierAreaArray}
          multiple
          addAreaListMethod={addAreaListMethod}
        />
      )}
    </>
  );
}
